import dayjs, { Dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export default function getFiscalization2Date(): Dayjs {
    let date = dayjs.tz('2025-01-01', 'Europe/Zagreb').startOf('day')
    return date
}

export function isLawInEffect(): boolean {
    const lawChangeDate = getFiscalization2Date()
    const today = dayjs().tz('Europe/Zagreb').startOf('day')
    return today.isAfter(lawChangeDate) || today.isSame(lawChangeDate)
}
